<template>
  <d2-container>
    <el-steps :active="2" align-center>
      <el-step title="步骤1" description="这是一段很长很长很长的描述性文字"></el-step>
      <el-step title="步骤2" description="这是一段很长很长很长的描述性文字"></el-step>
      <el-step title="步骤3" description="这是一段很长很长很长的描述性文字"></el-step>
      <el-step title="步骤4" description="这是一段很长很长很长的描述性文字"></el-step>
    </el-steps>
  </d2-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'sysUser',
    data() {
      return {}
    },
    created() {

    },
    computed: {
      ...mapGetters([
        'elements'
      ])
    },
    methods: {

    }
  }
</script>
